/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 历史活动信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class FindActivityHistoryInfoParams {
  constructor(public page: number, public size: number) {}
}

export default async function (
  params: FindActivityHistoryInfoParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.Page<cms.ActivityHistoryDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/activity-info/history`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
